import { useT } from '../i18n'
interface Props {
  title: string
  subtitle?: string
  onBack?: () => void
  right?: React.ReactNode
}

export function PageHeader({ title, subtitle, onBack, right }: Props) {
  const t = useT()
  return (
    <header className="flex items-center justify-between px-5 py-4 bg-brand-bg">
      <div className="flex items-center gap-3">
        {onBack && (
          <button
            onClick={onBack}
            className="w-9 h-9 flex items-center justify-center rounded-full
                       bg-brand-elevated active:bg-brand-border transition-colors"
            aria-label={t('Go back')}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M15 18l-6-6 6-6" stroke="#111111" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
        <div>
          <h1 className="font-display font-bold text-xl text-brand-text leading-tight">{title}</h1>
          {subtitle && <p className="text-xs text-brand-muted mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {right && <div>{right}</div>}
    </header>
  )
}
